export default (siteName) => [
    {
        path: 'trade-statement',
        name: 'trade-statement',
        component: () => import('@/components/dashboard/Finance/TradeStatementSetting/IndexPage.vue'),
        meta: {
            title: `收支項目設定${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'trade-statement-related-setting',
        name: 'trade-statement-related-setting',
        component: () => import('@/components/dashboard/Finance/TradeStatementSetting/RelatedSettingPage.vue'),
        meta: {
            title: `收支項目關聯設定${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'trade-statements-editor',
        name: 'trade-statements-editor',
        component: () => import('@/components/dashboard/Finance/TradeStatementsEditor/IndexPage.vue'),
        meta: {
            title: `收支項目範本編輯器${siteName}`,
            activeMenu: 'settings',
        },
    },
];
